import { init } from '@nosto/preact'

import serpComponent from './serp'
import categoryComponent from './category'
import autocompleteComponent from './autocomplete'
import historyComponent from './history'
import { defaultConfig, collectionGroupConfig } from './config'

import './styles/index.css'

let input = document.getElementById('inputSearch');
let formEl = input?.closest('form');
let searchIcon = formEl?.querySelector('button[type="submit"]');

const checkElements = (callback) => {
    if(input && formEl && searchIcon) {
        callback();
    } else {
        setTimeout(() => {
            input = document.getElementById('inputSearch');
            formEl = input?.closest('form');
            searchIcon = formEl?.querySelector('button[type="submit"]');
            checkElements(callback);
        }, 250)
    }
}

checkElements(() => {
    init({
        ...window.nostoTemplatesConfig,
        serpComponent,
        historyComponent,
        autocompleteComponent,
        categoryComponent,
        inputCssSelector: '#inputSearch',
        contentCssSelector: '#MainContent',
        // inputCssSelector: '',
        // contentCssSelector: '',
        serpUrlMapping: {
            query: 'q',
        },
        serpQuery: {
            name: 'serp',
            products: {
                size: defaultConfig.serpSize,
                from: 0,
            },
        },
        autocompleteQuery: {
            name: 'autocomplete',
            products: {
                size: defaultConfig.autocompleteSize,
            },
        },
        categoryCssSelector: '#MainContent .product-grid-container',
        isCategoryPage: () => location.pathname.startsWith('/collections') || document.querySelector('.nosto_page_type')?.textContent === 'category',
        categoryQuery: () => {
            if(document.querySelector('.nosto_category')) {
                const categoryId = document.querySelector('.nosto_category > .id').textContent;
                const isDiffuserRefill = !!collectionGroupConfig[categoryId];
                return {
                    name: 'serp',
                    products: {
                        categoryId,
                        size: (isDiffuserRefill) ? 50 : defaultConfig.serpSize,
                        from: 0,
                    }
                }
            }
        },
    })
    .then(() => {
        // SEARCH BAR FUNCTIONALITIES & ICONS
        const closeBtn = document.createElement("button");
        closeBtn.classList.add('ns-search-close-btn');
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("width", "20");
        svg.setAttribute("height", "20");
        svg.setAttribute("fill", "none");
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", "M2 2L17.556 17.556M2 18L17.556 2.444");
        path.setAttribute("stroke", "#000");
        path.setAttribute("stroke-width", "1.5");
    
        svg.appendChild(path);
        closeBtn.appendChild(svg);
        input.parentNode.appendChild(closeBtn);
    
        input.addEventListener('input', (e) => {
            const value = input.value.trim();
            if (value === '') {
                searchIcon.classList.remove('remove');
                closeBtn.classList.remove('active');
            } else {
                searchIcon.classList.add('remove');
                closeBtn.classList.add('active');
            }
        });
    
        closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            formEl.reset();
            closeBtn.classList.remove('active');
            searchIcon.classList.remove('remove');
        })
    
        searchIcon.addEventListener('click', (e) => {
            e.preventDefault();
            input.focus();
        })
    });
});